// src/utils/assetUrl.ts
export const assetUrl = (p: string) =>
    `${import.meta.env.BASE_URL}assets/${String(p).replace(/^\/+/, '')}`;